<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col>
          <div style="display:flex;justify-content: center;">
            <h4
              style=" display:flex;"
            >
              Checklists em tramitações
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  :title="'Checklists em tramitação, com pendência de ação por parte do Cliente (Checklist aguardando resposta) ou da equipe interna (Checklist respondido).'"
                  style="font-size: 0.85rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </h4></div>
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        style="flex-direction: column; margin-left: 0px;"
      >
        <div
          style="    display: flex;
                   align-items: center;"
        >
          <div
            :style="`background-color: #0079BF`"
            :class="['square', {'opcao-branca': '#0079BF' === '#FFFFFF'}]"
          />
          <div>Checklist Aguardando resposta</div>
        </div>

        <div
          style="    display: flex;
                    align-items: center;"
        >
          <div
            :style="`background-color: #7BC86C`"
            :class="['square', {'opcao-branca': '#7BC86C' === '#FFFFFF'}]"
          />
          <div>
            Checklist Respondido
          </div>
        </div>
        <div>
          &nbsp;
        </div>

      </b-row>
      <b-row
        align-h="center"
      >
        <donut-chart-comercial
          :id="$index"
          :dados="totalChecklist"
          :total="totalChecklist.totalPropostaStatus"
          :height="290"
        />
      </b-row>
      <b-col
        cols="auto"
        style="display: flex;align-items: center; border-top: 0.80px solid #82868b;justify-content:space-evenly;"
      >
        <div>
          <div
            style="display:flex;
             justify-content:center;
             align-items: center;"
          >
            <div
              :style="`background-color: #0079BF`"
              :class="['square', {'opcao-branca': '#0079BF' === '#FFFFFF'}]"
            />
            <div
              style="text-align: center;
            font-size: 16px;"
            >
              <b>

                Ação com Cliente
              </b>
            </div>
          </div>
          <div class="textogrande">
            <b>{{ totalChecklist.quantidade[1] }}</b>
          </div>
        </div>

        <div style="border-left: 0.80px solid #82868b; height: 50px;">
          &nbsp;
        </div>

        <div>
          <div
            style="display:flex;
             justify-content:center;
             align-items: center;"
          >
            <div
              style="background-color: #7BC86C;"
              :class="['square', {'opcao-branca': '#7BC86C' === '#FFFFFF'}]"
            />
            <div
              style="align-self: center;
              font-size: 16px;"
            >
              <b>
                Ação Interna
              </b>
            </div>
          </div>
          <div class="textogrande">
            <b>{{ totalChecklist.quantidade[0] }}</b>
          </div>
        </div>
      </b-col>
    </b-col>
  </b-row>
</template>

<style lang="scss">

.textogrande{
  margin-left: 65px;
  font-weight: bold;
  font-size: 22px;
}
.square {
  height: 10px;
  width: 10px;
  margin-right: 0.5rem;

}

.opcao-branca{
  border: 1px solid #82868b !important;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/dashboard-comercial/shared/services/api'

export default {
  name: 'DetalhamentoChecklist',
  components: {
    FontAwesomeIcon,
    DonutChartComercial: () => import('@/shared/components/donutchart-comercial/DonutChartComercial.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      carregado: false,
      totalChecklist: [],
      checklistTotal: null,
    }
  },
  created() {
    this.carregaDados()
  },
  methods: {
    carregaDados() {
      api.getTotalChecklist()
        .then(payload => {
          this.totalChecklist = payload.data
          this.checklistTotal = payload.data.totalDePropostas
          this.carregado = true
        })
    },
  },
}
</script>
